import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children }) {
  const { user, booting } = useAuth();
  const location = useLocation();

  if (booting) return null; // replace with spinner if you want
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;

  return children;
}
